import { FigmaTypography } from "@libs/zapi-ui/custom";

type TBlockCaptionProps = {
  caption?: string | null;
  className?: string;
};

export function BlockCaption({ caption, className = "mt-2" }: TBlockCaptionProps) {
  if (!caption) return null;
  return (
    <figcaption className={className}>
      <FigmaTypography variant="body-3" color="zinc500">
        {caption}
      </FigmaTypography>
    </figcaption>
  );
}
